import type { Testimonial } from '../components/Testimonials'

export const firstRoundTestimonials: Testimonial[] = [
  {
    quote:
      'Formals took eleven minutes. I timed them. That gave me back twenty-five minutes of golden hour I would have spent calling out names.',
    author: 'Hannah Whitfield',
    role: 'Wedding Photographer',
    location: 'Austin, TX · United States',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/307ee31e-ea25-4d68-be05-89a2cb4d82e7.jpg',
  },
  {
    quote:
      'I never ran out of things to say. Not once, all day. I just read the next line and kept shooting — the couple thought I was improvising.',
    author: 'Tom Bradshaw',
    role: 'Wedding Photographer',
    location: 'Manchester · United Kingdom',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/237f32ab-8d09-46a1-9057-ef4c9c8774be.jpg',
  },
  {
    quote:
      'The planner asked for my card at the end of the night. The review said I made everything so easy. All I did was run the run sheet.',
    author: 'Amara Boateng',
    role: 'Wedding & Elopement Photographer',
    location: 'Toronto, ON · Canada',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/077759a9-fcd9-4bf1-9414-731193cd2181.jpg',
  },
]

export const secondRoundTestimonials: Testimonial[] = [
  {
    quote:
      'Volume 4 alone paid for this. Calling smallest to largest, by name — fifty minutes of formals became fourteen, and nobody wandered off.',
    author: 'Rachel Doyle',
    role: 'Wedding Photographer',
    location: 'Byron Bay, NSW · Australia',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/2d3f9b7c-60b6-453b-a4b3-8668b3e577c7.jpg',
  },
  {
    quote:
      'Hair ran forty-five minutes late. I opened the Break Points table, knew exactly what to cut, and still got the portraits. Third season and that has never happened before.',
    author: 'Daniel Kwan',
    role: 'Wedding Photographer, 3rd season',
    location: 'Auckland · New Zealand',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/e00d842a-fa20-4950-ade7-af1c7d84647a.jpg',
  },
  {
    quote:
      'I used a Phrase Book line on the aunt who was directing my formals. She laughed, stepped back, and the groom said thank you afterwards.',
    author: 'Niamh Kelly',
    role: 'Wedding Photographer',
    location: 'Galway · Ireland',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/1ff92b7d-e47f-4a89-a481-20b55a668d9d.jpg',
  },
]
